// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"e529a356","309":"391116f3"}[chunkId] + ".chunk.js";
};